export default __webpack_public_path__ + "static/media/refinador.6b2f3e39.png";